<template>
   <label class="input-name__label" for="name">
      <span>{{ $t('Registration.Name.enterName') }}</span>
      <input
         type="text"
         id="name"
         autocomplete="name"
         ref="inputField"
         @input="handlerUserInput"
         maxlength="32"
         name="firstName"
         placeholder="Имя"
         @blur="loseFocus"
         v-model="userInput"
      />
   </label>
</template>

<script>
export default {
   props: {
      needValidation: {
         type: Boolean,
         default: true,
      },
   },

   data() {
      return {
         userInput: '',
         isValid: false,
      };
   },

   mounted() {
      if (sessionStorage.name) {
         this.userInput = sessionStorage.name;
      }
   },

   watch: {
      userInput() {
         this.$emit('userInput', this.userInput);
         sessionStorage.name = this.userInput;
         this.validate();
         this.$refs['inputField'].classList.remove('error');
      },

      isValid() {
         this.$emit('isValid', this.isValid);
      },
   },

   methods: {
      loseFocus() {
         if (this.isValid) {
            return;
         }

         if (this.needValidation) {
            this.$refs['inputField'].classList.add('error');

            let removeError = setTimeout(() => {
               this.$refs['inputField'].classList.remove('error');
               clearTimeout(removeError);
            }, 2000);
         }
      },

      handlerUserInput() {
         this.userInput = this.$refs['inputField'].value;
         this.validate();
      },

      validate() {
         if (this.userInput.length > 0) {
            this.isValid = true;
            return;
         }
         this.isValid = false;
      },
   },
};
</script>

<style lang="sass" scoped>
label
   width: 100%
   display: block
   position: relative

   &::before
      content: url('../../assets/img/user.svg')
      position: absolute
      top: 56%
      left: 1rem
      width: 20px
      height: 20px

   & span
      text-transform: uppercase
      font-size: 0.8rem
      letter-spacing: 0.04em

   & > *
      display: block

input
   width: 100%
   border: 1px solid #ccc
   border-radius: 4px
   padding: 1rem 1rem 1rem 3rem
   font-size: 1rem
   margin-top: 0.5rem

.error
   border: 1px solid red !important
</style>